/**
 * Phase 19 — under the rotation / the share bar: the gateways a rule set
 * aside as the last resort and the ones it took out of the pool today.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DraftGateway } from '../../../../drop-generator.types';
import type { RotationView } from '../ranking/formula-pool';
import { GatewayChip } from './GatewayChip';

const Chips: FC<{ gateway: DraftGateway; indexes: number[]; struck?: boolean }> = ({ gateway, indexes, struck }) => (
  <>
    {indexes.map((i) => (
      <GatewayChip key={gateway.pool[i].id} index={i} struck={struck} />
    ))}
  </>
);

export const RuleOutcomeLine: FC<{ gateway: DraftGateway; view: RotationView }> = ({ gateway, view }) => {
  if (view.reserve.length === 0 && view.left.length === 0) return null;
  return (
    <span className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
      {view.reserve.length > 0 ? (
        <span className="flex items-center gap-1.5">
          Last resort — only when the others are full: <Chips gateway={gateway} indexes={view.reserve} />
        </span>
      ) : null}
      {view.left.length > 0 ? (
        <span className="flex items-center gap-1.5">
          {view.reserve.length > 0 ? '· ' : ''}Out of the pool by a rule: <Chips gateway={gateway} indexes={view.left} struck />
        </span>
      ) : null}
    </span>
  );
};
